import { EventDay } from "../../models";

var moment = require("moment");

/**
 * Sorts the eventClasses so that the first element is the smallest number and the last element is the largest number
 * 
 * @param data 
 * @returns eventClasses sorted smallest number to largest number
 */
export function sortEventDays(data: EventDay[]) {
    try {
        let result: EventDay[] = [];
        if (data && data.length) {
            result = data.sort((a,b) => new moment(a.awsdate).format("YYYYMMDDHHmmss") - new moment(b.awsdate).format("YYYYMMDDHHmmss"));
        }
        return result;
    } catch (error: any) {
        console.error("Error sorting data for type: eventDay");
        console.error(error);
        return null;
    }
};